export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./modifyProvider.vue?vue&type=template&id=52050b7e&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/modifyProvider.vue?vue&type=template&id=52050b7e&scoped=true
// module id = 2470
// module chunks = 31